import { Select, Text } from "@mantine/core";
import { EventVenue } from "../ExistingEventCard/types";

interface VenueSelectorProps {
  label: string;
  placeholder: string;
  selectedVenueId: number | null;
  venues: EventVenue[];
  venueType: "RESTAURANT" | "AFTER_PARTY";
  onChange: (venueId: number | null) => void;
}

export const VenueSelector = ({
  label,
  placeholder,
  selectedVenueId,
  venues,
  venueType,
  onChange,
}: VenueSelectorProps) => {
  const filteredVenues = venues.filter((v) => v.type === venueType);

  const venueOptions = filteredVenues.map((venue) => ({
    value: String(venue.id),
    label: venue.locationName ? `(${venue.locationName}) ${venue.name}` : venue.name,
  }));

  return (
    <>
      <Text size="sm" fw={500} c="black">
        {label}
      </Text>
      <Select
        placeholder={placeholder}
        data={venueOptions}
        value={selectedVenueId ? String(selectedVenueId) : null}
        onChange={(value) => onChange(value ? Number(value) : null)}
        clearable
        searchable
        styles={{ option: { color: "black" } }}
      />
    </>
  );
};
